import type { HostList } from '@lib/types/Server';

export const defaultHostList: HostList = window.LEADNIZE_SETTINGS.server_list;
export const defaultHostKey = window.LEADNIZE_SETTINGS.default_server;
